import React from "react";
import faqData from "../../assets/faq.json";

export default class FAQ extends React.Component {

    render() {
        return (
            <div className="container">
                <div className="section-title">
                    <h2>Frequently Asked Questions</h2>
                </div>
                <div className="accordion-list">
                    <ul>
                        {faqData.map((faq, i) => {
                            return (
                                <li key={i + 1}>
                                    <i className="bx bx-help-circle icon-help"></i>{" "}
                                    <a
                                        href="!#"
                                        data-bs-toggle="collapse"
                                        className="collapse collapsed"
                                        data-bs-target={"#accordion-list-" + (i + 1)}>
                                        {faq.question}
                                        <i className="bx bx-chevron-down icon-show"></i>
                                        <i className="bx bx-chevron-up icon-close"></i>
                                    </a>
                                    <div
                                        id={"accordion-list-" + (i + 1)}
                                        className="collapse"
                                        data-bs-parent=".accordion-list">
                                        <p>{faq.answer}</p>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }
};
